module.exports = __webpack_public_path__ + "static/media/Menu-3.0a24be55.jpg";